import { render, staticRenderFns } from "./StockPlaceMoldForm.vue?vue&type=template&id=4c8123a8&"
import script from "./StockPlaceMoldForm.vue?vue&type=script&lang=js&"
export * from "./StockPlaceMoldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports